import { apiClient } from '@/utils/api-client'

const API_INTERNAL_BASE = '/payment-authentication'

/**
 * Payment authentication service for the hosted "authenticate payment" page the
 * 3-D Secure email links to. The link carries its own signature, so these calls
 * need no session.
 */
class PaymentAuthenticationService {
    /**
     * Fetch what the page shows for a payment: its state and, while it is still
     * waiting on the customer, what Stripe.js needs to confirm it with their bank.
     *
     * @param {string} paymentUlid - Payment ULID
     * @param {string} signature - Link signature
     * @returns {Promise<Object>} Payment data: state ('requires_action', 'paid',
     *   'failed' or 'processing'), account_name, invoice_number, amount (cents),
     *   currency, client_secret, payment_method_id, stripe_public_key
     */
    async show(paymentUlid, signature) {
        return await apiClient
            .get(API_INTERNAL_BASE + '/' + paymentUlid, {
                params: { signature },
            })
            .then((response) => response.data.data)
    }

    /**
     * Tell the API the customer's browser has finished with their bank, so it
     * brings the payment up to date and says what it is now.
     *
     * @param {string} paymentUlid - Payment ULID
     * @param {string} signature - Link signature
     * @returns {Promise<Object>} Payment data, as for show() but without a client_secret
     */
    async complete(paymentUlid, signature) {
        return await apiClient
            .post(API_INTERNAL_BASE + '/' + paymentUlid, null, {
                params: { signature },
            })
            .then((response) => response.data.data)
    }
}

export default new PaymentAuthenticationService()
